import React from 'react';
import { FadeInSection } from '../ui/MotionPrimitives';

const CoreMission: React.FC = () => {
  return (
    <FadeInSection className="w-full bg-[#D88546] py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="relative rounded-[32px] bg-[#D88546] text-white">
          {/* Opening quote top-left */}
          <span className="pointer-events-none absolute -top-6 left-0 text-5xl font-semibold text-white md:-top-8 md:text-6xl">
            “
          </span>

          <div className="flex flex-col gap-10 md:flex-row md:gap-16">
            {/* Left: Our Core Mission + quote */}
            <div className="md:w-1/2 space-y-4 text-center">
              <h2 className="text-sm font-semibold uppercase tracking-[0.14em]">
                Our Core Mission
              </h2>
              <p className="text-[16px] leading-relaxed md:text-[16px]">
                “At Hogar Dorado House, we don't just invest in properties—we invest in potential.
                With precision, insight, and integrity, we transform market intelligence into
                enduring value for our clients and partners across the globe.”
              </p>
            </div>

            {/* Right: Vision text */}
            <div className="md:w-1/2 space-y-3 text-center text-sm leading-relaxed md:text-base">
              <h3 className="text-[14px] font-semibold uppercase tracking-[0.12em]">
                Vision: Building a Legacy of Success
              </h3>
              <p>
                We aim to build long-lasting relationships and a legacy of success by exceeding the
                expectations of our partners and clients. By fostering collaboration, trust, and
                transparency, we ensure each transaction contributes to the growth and prosperity of
                all involved.
              </p>
            </div>
          </div>

          {/* Closing quote bottom-right */}
          <span className="pointer-events-none absolute -bottom-6 right-0 text-5xl font-semibold text-white md:-bottom-8 md:text-6xl">
            ”
          </span>
        </div>
      </div>
    </FadeInSection>
  );
};

export default CoreMission;
